// 深度の制限値
export const DEPTH_LIMITS = {
    MIN: 0, // 最小深度
    MAX: 10, // 最大深度
    FREE_TIER_MAX: 3, // 無料版の最大深度
};
// 痛みレベルの閾値（100倍スケール：DBには整数で保存）
export const PAIN_THRESHOLDS = {
    MIN: 0, // 最小痛みレベル
    MAX: 10000, // 最大痛みレベル (100.00)
    DEATH: 10000, // 死亡閾値 (100.00)
    WARNING: 8000, // 警告レベル (80.00)
    RECOVERY_RATE: 50, // 回復速度（毎秒） (0.10)
};
// 苦痛レベルの閾値（100倍スケール：DBには整数で保存）
export const SUFFERING_THRESHOLDS = {
    MIN: 0, // 最小苦痛レベル
    MAX: 10000, // 最大苦痛レベル (100.00)
    DEATH: 10000, // 死亡閾値 (100.00)
    DARKNESS_START: 5000, // 画面暗転が始まる閾値 (50.00)
    BLUR_START: 3000, // 画面ぼかしが始まる閾値 (30.00)
};
// 深淵死の時間（深度10に30分滞在で死亡）
export const ABYSS_DEATH_TIME = 30 * 60 * 1000; // 30分（ミリ秒）
// 深度別のテキスト表示速度（ミリ秒/文字）
export const TEXT_DISPLAY_SPEEDS = {
    0: 50, // 通常速度
    1: 100, // 少し遅い
    2: 150, // 遅い
    3: 200, // かなり遅い
    4: 300, // 苦痛を感じる遅さ
    5: 400, // 明らかに遅い
    6: 500, // 非常に遅い
    7: 700, // 耐え難い遅さ
    8: 900, // 極めて遅い
    9: 1200, // ほぼ停止
    10: 1500, // 地獄のような遅さ
};
// テキスト腐敗に使用する文字（日本語）
export const CORRUPTION_CHARS_JA = ['…', '、', '‥'];
// テキスト腐敗に使用する文字（英語）- 挿入用（半角のみ）
export const CORRUPTION_CHARS_EN = ['..', '_', ' '];
// 言語を判定して適切な腐敗文字を返す
export const CORRUPTION_CHARS = {
    ja: CORRUPTION_CHARS_JA,
    en: CORRUPTION_CHARS_EN,
    auto: (text) => {
        // 日本語文字が含まれているかチェック
        const hasJapanese = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/.test(text);
        return hasJapanese ? CORRUPTION_CHARS_JA : CORRUPTION_CHARS_EN;
    }
};
// メッセージの最大バイト数
export const MESSAGE_MAX_BYTES = 180; // 英語180文字、日本語60文字相当
// スケール変換ヘルパー関数
export const Scale = {
    // DBから読み取った値を表示用に変換（100で割る）
    fromDB: (value) => value / 100,
    // 表示用の値をDB保存用に変換（100倍する）
    toDB: (value) => Math.floor(value * 100),
};
